<template>
	<div class="">
		<div class="row col-md-12 justify-content-center">
   <h5>{{ labels.title }} </h5> 
		</div>
		<b-row class="">
			<b-col cols="3" class="text-left">
    <h5>{{labels.fechaProceso}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<input type="date" v-model="fechaProceso" class="form-control" v-on:focus="fgl_guardar=false">
			</b-col>
			<b-col cols="4"></b-col>
		</b-row>
		<b-row class="">
			<b-col cols="3" class="text-left">
    <h5>{{labels.fechaFinal}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left align-self-end">
				<input type="date" v-model="fechaFinal" class="form-control" v-on:focus="fgl_guardar=false">
			</b-col>
			<b-col cols="4"><h5> {{f_calcula_cuotas(fechaProceso,fechaFinal,30)}} (Meses) </h5> </b-col>
		</b-row>
		<b-row class="mt-2">
			<b-col cols="8" class="text-left">
    <h5>{{ labels.condicionesTasa }}</h5> 
			</b-col>
			<b-col cols="4" class="text-left">
				<h6><select v-model="cambioTasa" value="NO">
					<option value="NO" >NO</option>
					<option value="SI" >SI</option>
				</select></h6>
			</b-col>
		</b-row>
		<b-row class="" v-if="cambioTasa=='SI'">
			<b-col cols="3" class="text-left">
    <h5>{{labels.tasa}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<select v-model="tasaCondTasa" class="form-control" v-on:click="valideTasa()" v-on:focus="fgl_guardar=false">
    <option value="">{{ labels.select }}</option> 
    <option v-for="tipTasa in listTipoTasa" :key="tipTasa?.id" :value="tipTasa?.tipo_tasa">{{ tipTasa?.descripcion }}</option> 
				</select>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5>+</h5>
			</b-col>
			<b-col cols="3" class="text-left">
				<input type="number" v-model="puntosAdiciCondTasa" class="form-control" v-on:focus="fgl_guardar=false">
			</b-col>
		</b-row>
		<b-row class="" v-if="cambioTasa=='SI'">
			<b-col cols="3" class="text-left">
    <h5>{{labels.frecuencia}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<select v-model="frecuenciaCondTasa" class="form-control" v-on:focus="fgl_guardar=false">
    <option value="">{{ labels.select }}</option> 
				<option value="30">30 días</option>
				<option value="60">60 días</option>
				<option value="90">90 días</option>
				<option value="180">180 días</option>
				<option value="360">360 días</option>
				</select>
			</b-col>
			<b-col cols="4" class="text-left">
				<select v-model="modalidad" class="form-control" v-on:focus="fgl_guardar=false">
    <option value="">{{ labels.select }}</option> 
    <option value="A">{{ labels.anticipada }}</option> 
    <option value="V">{{ labels.vencida }}</option> 
				</select>
			</b-col>
		</b-row>
		<b-row class="mt-2">
			<b-col cols="8" class="text-left">
    <h5>{{ labels.condCambioCanon }} </h5> 
			</b-col>
			<b-col cols="4" class="text-left">
				<h6><select v-model="cambioIncremento" value="NO">
					<option value="NO" >NO</option>
					<option value="SI" >SI</option>
				</select></h6>
			</b-col>
		</b-row>
		<b-row class="" v-if="cambioIncremento=='SI'">
			<b-col cols="3" class="text-left">
    <h5>{{labels.incremento}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<select v-model="tasaCambCanon" class="form-control">
    <option value="">{{ labels.select }}</option> 
    <option v-for="tipTasa in listTipoTasa" :key="tipTasa?.id" :value="tipTasa?.tipo_tasa">{{ tipTasa?.descripcion }}</option> 
				</select>
			</b-col>
			<b-col cols="1">+</b-col>
			<b-col cols="3" class="text-left">
				<input type="number" v-model="puntosAdiciCambCanon" class="form-control" @blur="calculaNewCanon()" v-on:focus="fgl_guardar=false">
			</b-col>
		</b-row>
		<b-row class="" v-if="cambioIncremento=='SI'">
			<b-col cols="3" class="text-left">
    <h5>{{labels.periodicidadCambio}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<input type="number" v-model="periodCambioCanon" class="form-control">
			</b-col>
			<b-col cols="1"></b-col>
			<b-col cols="3"><h5>Meses</h5></b-col>
		</b-row>
		<b-row class="">
			<b-col cols="3" class="text-left">
    <h5>{{labels.valorCanon}}</h5> 
			</b-col>
			<b-col cols="5" class="text-left">
				<input type="number" v-model="valorCanon" class="form-control" v-on:change="fgl_guardar=false;a_flujos_contrato=[]">
			</b-col>
			<b-col cols="1"></b-col>
                        <b-col cols="3">
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="10" class="d-flex justify-content-end">
    <b-button type="button" id="create-btn" @click="flujosContrato">{{ labels.flujos }}</b-button> 
    <b-button v-if="fgl_guardar==false" type="button" id="create-btn" @click="validarContrato">{{ labels.validar }}</b-button> 
    <b-button v-else type="button" id="create-btn" @click="saveModDetalle">{{ labels.save }}</b-button> 
			</b-col>
			<b-col cols="2" class="d-flex justify-content-end">
    <b-button type="button" id="create-btn" @click="cierraModal">{{ labels.close }}</b-button> 
			</b-col>
		</b-row>
        <ModFlujosContrato :modFlujosContrato="showFlujosContrato" :aFlujosContrato='a_flujos_contrato' :valor_canon='valorCanon' :numero_cuotas='numero_cuotas' @flujosContratoFC="f_flujosContrato" @cierraModalFC="closeModalFC"></ModFlujosContrato>
	</div>
</template>

<script>
import TipoTasa from '../../services/TipoTasas' 
import ContratoCuota from '../../services/ContratoCuota' 
import Tasas from '../../services/Tasas' 
import ModFlujosContrato from './ModFlujosContrato.vue'; 
export default {

name : 'ModificacionDetalle',
components : {  ModFlujosContrato },
props:['dataContrato'],
data : () => ({
	cambioTasa: "NO",
	cambioIncremento: "NO",
	fechaProceso : '',
	fechaFinal : '',
	tasaCambioCanon : '',
	puntosAdiciCondTasa : '',
	frecuenciaCondTasa : '',
	cambioCanon : '',
	tasaCondTasa : '',
	tasaCambCanon : '',
	listTipoTasa : [],
	puntosAdiciCambCanon : '',
	periodCambioCanon : '',
	valorCanon : '',
	modalidad : '',
	tasaIncremento : '',
	fgl_guardar : false,
        showFlujosContrato : false,
        a_flujos_contrato : [],
	numero_cuotas : 0,
    }),
computed:{
labels(){
    if(this.$store.state._language == "es-ES"){ 
	return {
		title : 'Modificación detalle',
		condicionesTasa : 'Cambio condiciones de tasa ?',
		condCambioCanon : 'Cambio condiciones incremento canon?',
		cambioCanon : 'Cambio canon',
		fechaProceso : 'Fecha proceso',
		fechaFinal : 'Fecha final',
		tasa : 'Tasa',
		incremento : 'Incremento',
		puntosAdicionales : 'Puntos adicionales',
		periodicidadCambio : 'Cada',
		valorCanon : 'Valor canon',
		frecuencia : 'Frecuencia de pago',
		modalidad : 'Modalidad',
		anticipada : 'Anticipada',
		fija : 'Fija',
		vencida : 'Vencida',
  select : 'Seleccione...', 
		save : 'Guardar',
		validar : 'Validar',
		close : 'Cerrar',
		flujos: 'Flujos',
	}
    }else{
	return {
		title : 'Detail modificacion',
		condicionesTasa : 'Change rate conditions?',
		condCambioCanon : 'Change Canon increase conditions?',
		cambioCanon : 'Canon change',
		fechaProceso : 'Process date',
		fechaFinal : 'EndDate',
		tasa : 'Rate',
		puntosAdicionales : 'Additional points',
		periodicidadCambio : 'Periodicity of change',
		valorCanon : 'Canon value',
		frecuencia : 'Payment frequency',
		modalidad : 'Modality',
		anticipada : 'Anticipated',
		fija : 'Fixed',
		vencida : 'Overdue',
  select : 'Select...', 
		save : 'Save',
		validar : 'Validate',
		close : 'Close',
		flujos: 'Flows',
	}
}
}
},
methods:{
flujosContrato(){
	if (this.valorCanon == null || this.fechaFinal == null || 
		this.fechaProceso == null ) { 
		return
	}
	this.numero_cuotas = this.f_calcula_cuotas( 
	this.fechaProceso,this.fechaFinal,this.dataContrato.frecuencia) 
	if (this.a_flujos_contrato.length == 0) { 
		for (let idx=0;idx<this.numero_cuotas;idx++) { 
			this.a_flujos_contrato.push({cuota: idx+1, valor: this.valorCanon}) 
		}
	}
	this.showFlujosContrato = true 
},
closeModalFC(){
	this.showFlujosContrato = false 
},
cierraModal(){
	this.$emit('cierraModal',false) 
},
validarContrato(){
	if (this.fechaProceso < this.dataContrato.fecha_inicial){ 
		this.$toast.error(`La fecha proceso no puede ser menor a ${this.dataContrato.fecha_inicial}`) 
		return
	}
	let datos = [
		this.fechaProceso, 
		this.fechaFinal, 
		this.valorCanon, 
	]

	if(datos.includes('')){ 
		this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
		this.fgl_guardar=false 
	}else{
		this.fgl_guardar=true 
	}
},
saveModDetalle(){

	if (this.fechaProceso < this.dataContrato.fecha_inicial){ 
		this.$toast.error(`La fecha proceso no puede ser menor a ${this.dataContrato.fecha_inicial}`) 
		return
	}
	const cantidadCuotas = this.f_calcula_cuotas( 
		this.fechaProceso,this.fechaFinal,this.dataContrato.frecuencia) 
		if (this.a_flujos_contrato.length == 0) { 
			for	(let idx=0;idx<cantidadCuotas;idx++) {
				this.a_flujos_contrato.push({cuota: idx+1, valor: this.valorCanon}) 
			}
		}
		if (this.cambioTasa == "NO") { 
			this.tasaCondTasa="" 
			this.puntosAdiciCondTasa="" 
			this.frecuenciaCondTasa == "" 
			this.modalidad = "" 
		}
		if (this.cambioIncremento == "NO") { 
			this.tasaCambCanon="" 
			this.puntosAdiciCondTasa="" 
			this.frecuenciacambTasa == "" 
			this.periodCambioCanon = "" 
		}
		let datos = {
			'fechaInicial' : this.fechaProceso, 
			'fechaFinal' : this.fechaFinal, 
			'tasaCondTasa' : this.tasaCondTasa == "" ? this.dataContrato.tipo_tasa : this.tasaCondTasa, 
			'tasaCambCanon' : this.tasaCambCanon, 
			'puntosAdiciCondTasa' : this.puntosAdiciCondTasa == "" ? this.dataContrato.tasa : this.puntosAdiciCondTasa, 
			'frecuenciaCondTasa' : this.frecuenciaCondTasa == "" ? this.dataContrato.frecuencia : this.frecuenciaCondTasa, 
			'puntosAdiciCambCanon' : this.puntosAdiciCambCanon, 
			'periodCambioCanon' : this.periodCambioCanon, 
			'valorCanon' : this.valorCanon == "" ? this.dataContrato.canon_arrendamiento : this.valorCanon, 
			'valorContrato' : this.dataContrato.valor_contrato, 
			'modalidad' : this.modalidad == "" ? this.dataContrato.modalidad : this.modalidad, 
			'cantidadCuotas' : cantidadCuotas,
			'nro_contrato' : this.dataContrato.nro_contrato, 
			'idUser' : this.$store.state.userId, 
			'aFlujosContrato' : this.a_flujos_contrato, 
			'cambioTasa' : this.cambioTasa, 
		}
		this.cierraModal() 
		ContratoCuota.createContratoCuota(datos) 
		.then((res) => { 
			this.$toast.success(res.data.message) 
			this.$router.push({ name: "consultarcontrato" }); 
		})
			.catch((err) => { 
		console.log(err); 
	})
},
async calculaNewCanon(){
	const codTasa = this.tasaCambCanon 
	if (codTasa.length > 0) { 
		Tasas.getTasaByFechaIniAndCodTasa(this.fechaProceso,codTasa) 
		.then((res) => { 
			this.tasaIncremento = parseFloat(res.data.tasaByCodByFechaIni.valor) 
			this.valorCanon = Math.round(this.dataContrato.canon_arrendamiento) * (1+(this.tasaIncremento+Number(this.puntosAdiciCambCanon))/100) 
		})
		.catch((err) => console.log(err)) 
	}
},
f_calcula_cuotas (fecha_inicial,fecha_final,frecuencia) {
	if	(fecha_inicial == null || fecha_final == null || frecuencia == null) {
		return 0
	}
	const añoinicial = fecha_inicial.substring(0,4) 
	const mesinicial = fecha_inicial.substring(5,7) 
	let añofinal = fecha_final.substring(0,4) 
	const mesfinal = fecha_final.substring(5,7) 
	if	(añoinicial>añofinal || añoinicial==añofinal && mesinicial>=mesfinal) {
		return 0
	}
	let cuotas=mesfinal-mesinicial

	if	(cuotas < 0) {
		cuotas=12+cuotas
		añofinal=añofinal-1
	}
	cuotas=cuotas+(añofinal-añoinicial)*12
	cuotas=cuotas*30
	cuotas=cuotas/frecuencia
	return cuotas
},
valideTasa(){

	if (this.fechaProceso == "null" || this.fechaProceso == "undefined") { 
		return;
	}
	if (this.tipos_tasa == "null") { 
		return;
	}
	const v_tipo_tasa = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.tipo_tasa==this.tasaCondTasa) 
	const fgl_zscore = v_tipo_tasa.descripcion.substr(0,6) == "Zscore" 
	const fgl_interpolado = v_tipo_tasa.descripcion.includes("Interpolado") 
	if	(fgl_zscore && (fgl_interpolado == false ||
		this.puntosAdiciCondTasa == "0" || 
		this.puntosAdiciCondTasa.length==0)) { 
		let cuotas=this.f_calcula_cuotas(this.fechaProceso,this.fechaFinal,30)/12 
		let nro_cuotas = cuotas.toFixed(2) 
		let proxima_cuota = cuotas.toFixed(0) 
		proxima_cuota = proxima_cuota+".00" 
		const v_interpolado = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion.includes("Interpolado")) 
		if	(nro_cuotas != proxima_cuota) {
			if (v_tipo_tasa.descripcion.includes("Interpolado")) { 
				return
			}
			this.tasaCondTasa=v_interpolado.tipo_tasa 
			this.f_tasa_interpolacion(this.fechaProceso,this.f_calcula_cuotas(this.fechaProceso,this.fechaFinal,30)) 
		} else {
			this.puntosAdiciCondTasa = 0 
			proxima_cuota=proxima_cuota.replace(".00","") 
			let v_descripcion="Zscore "+proxima_cuota+" año"
			if (proxima_cuota > "1" || proxima_cuota.length > 1) { 
				v_descripcion=v_descripcion+"s"
			}
			const v_tasa_score = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion==v_descripcion) 
			if	(v_tasa_score == undefined) {
				this.tasaCondTasa=v_interpolado.tipo_tasa 
				this.f_tasa_interpolacion(this.fechaProceso,this.f_calcula_cuotas(this.fechaProceso,this.fechaFinal,30)) 
				return
			}
			this.tasaCondTasa=v_tasa_score.tipo_tasa 
		}
	}
},
f_tasa_interpolacion(fechaInicial,cuotas) {
	Tasas.interpolacion(fechaInicial,cuotas) 
	.then((res) => { 
		this.puntosAdiciCondTasa = res.data.tasa 
	})
	.catch((err) => console.log(err)) 
},
f_flujosContrato(infoFlujosContrato){
	this.a_flujos_contrato = infoFlujosContrato 
	this.showFlujosContrato = false 
},
},
mounted(){
        TipoTasa.getAllTipoTasas() 
        .then((res) => { 
            // console.log(res.data); 
            this.listTipoTasa = res.data.listTipoTasas 
        })
        .catch((err) => console.log(err)) 
    },
}
</script>
